import { getDataItem, getDataList, getError, getId, getIsLoading, getSuccess, getTotal } from "@/store/Crud/functions/getters";
export const getGroups = (state) => state.groups;
export const getQuestions = (state) => state.questions;
export default {
    getError,
    getIsLoading,
    getDataItem,
    getSuccess,
    getDataList,
    getTotal,
    getId,
    getGroups,
    getQuestions,
};
